import React, { useEffect, useState } from "react";
import styles from "../Doubt/summary-list.module.css";
import { useRoot } from "../../../context/RootContext";
import { useMediaQuery } from "react-responsive";
import { usePractice } from "../../../context/PracticeContext";
import { renderContent } from "../../../utils/TutorConstants";
import ChatImg from "../../../assets/ai-tutor/chat.svg";
import { getJourneysByUser } from "../../../network/LearnApiService";
import { useTutor } from "../../../context/AiTutorContext";
import { useNavigate } from "@remix-run/react";
import { tutorString } from "../../../utils/common-utils";
import { StorageService } from "../../../utils/StorageUtils";

export default function PracticeHistoryList() {
  const [JourneyList, setJourneyList] = useState([]);
  const { togglePracDrawer } = useRoot();
  const { selectedSubTopic } = useTutor();
  const { setSelectedJourney, selectedJourney, setMediaDetails } =
  usePractice();
  const isMobile = useMediaQuery({
    query: "(max-width: 768px)"
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchJourneys();
  }, [selectedSubTopic]);
  const fetchJourneys = async () => {
    let { success, data } = await getJourneysByUser();
    if (success) {
      data = data?.filter((item) => item.sub_topic_id == selectedSubTopic?.id);
      setJourneyList(data);
    }
  };

  return (
    <div>
      {JourneyList?.map((item, index) => {
        return (
          <div
            key={item?._id || index}
            className={styles["query-container"]}
            onClick={() => {
              if (isMobile) {
                togglePracDrawer();
              }
              setSelectedJourney(item?._id);
              StorageService.setItem("ReviewJourneyId", item?._id);
              navigate(`${tutorString}/review`, {
                state: {
                  journeyId: item?._id
                }
              });
              setMediaDetails([]);
            }}>

            <img src={ChatImg} className={styles["chat-img"]} />
            <div
              className={`${styles["query-text"]} ${
              selectedJourney == item?._id ? styles["bold"] : ""}`
              }>

              {renderContent("Practice " + (index + 1), true)}
            </div>
          </div>);

      })}
    </div>);

}